import { Box, Grid, Typography } from '@material-ui/core';
import { isNotBlank } from '@roc/feature-utils';
import {
  AddressDetailsField,
  createDateField,
  createNumberFormatField,
  createSelectField,
  createTextField,
} from '@roc/ui';
import { rentalExperienceOptions } from 'libs/feature-borrower-loan-submission/src/modules/newLoanApplication/utils/loanApplicationConstants';
import { QuoteTypeStore } from 'libs/feature-one-tool/src/quote/stores/quoteTypeStore';
import { observer } from 'mobx-react';
import { OneToolCard } from './oneToolCard';
import {
  CitizenshipStatus,
  createCheckboxField,
} from '@roc/client-portal-shared/components';
import { PercentagePicker } from 'libs/feature-one-tool/src/quote/steps/leverage/components/leverageComponents';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  infoMessage: {
    fontStyle: 'italic',
    marginTop: '0rem',
    marginLeft: '1rem',
    color: 'gray',
    fontSize: '12px',
  },
}));

export const BorrowerInformationForm = observer(({ borrowerFormStore }) => {
  const classes = useStyles();
  const store = borrowerFormStore;
  const readOnly = false;
  const displayPGField = true;
  const showOwnershipPercentage = true;
  return (
    <Grid container direction="row" spacing={2}>
      <Grid item xs={12} sm={6}>
        {createTextField({
          store,
          testId: 'firstName',
          fieldName: 'firstName',
          label: 'First Name',
          disabled: readOnly,
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createTextField({
          store,
          testId: 'lastName',
          fieldName: 'lastName',
          label: 'Last Name',
          disabled: readOnly,
        })}
      </Grid>
      <Grid item xs={12}>
        {createTextField({
          store,
          testId: 'emailAddress',
          fieldName: 'emailAddress',
          label: 'Email Address',
          disabled: readOnly,
        })}
      </Grid>

      <Grid item xs={12} sm={6}>
        {createNumberFormatField({
          store,
          label: 'FICO Score',
          fieldName: 'ficoProvidedAtOrigination',
          testId: 'ficoProvidedAtOrigination',
          onChange: value =>
            borrowerFormStore.onFieldChange(
              'ficoProvidedAtOrigination',
              value ? parseInt(value) : ''
            ),
        })}
      </Grid>
      <Grid item xs={12} sm={6}>
        {createSelectField({
          store,
          testId: 'rentalExperience',
          fieldName: 'rentalExperience',
          label: 'Number of Verified Investment Properties',
          options: rentalExperienceOptions,
        })}
      </Grid>
      <Grid item xs={12}>
        <CitizenshipStatus store={store} />
      </Grid>
      {displayPGField && (
        <Grid item xs={showOwnershipPercentage ? 8 : 12}>
          <Grid container justifyContent="center" alignItems="center">
            <Grid item>
              {createCheckboxField({
                store,
                fieldName: 'personalGuarantor',
                label: 'This borrower is a personal guarantor for the loan.',
              })}
            </Grid>
            <Grid item>
              <Typography
                variant="body2"
                className={classes.infoMessage}
                style={{ textAlign: 'center' }}
              >
                If yes, the borrower's credit and background reports are needed.
                if no, only a background report is needed.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
      {showOwnershipPercentage && (
        <Grid item xs={4}>
          <Box display="flex" flexDirection="column" alignItems="center" pb={1}>
            <PercentagePicker
              label="Ownership Percentage"
              fieldName="pctOwnership"
              value={store.form.fields.pctOwnership.value}
              onChange={val => store.onFieldChange('pctOwnership', val)}
            />
          </Box>
          <Typography
            variant="body2"
            style={{ textAlign: 'center' }}
            className={classes.infoMessage}
          >
            *If greater than 51%, the borrower must be a personal guarantor.
          </Typography>
        </Grid>
      )}
    </Grid>
  );
});
